import React, { Component, Fragment } from "react";
import Breadcrumb from "../../common/breadcrumb";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import Datatable from "./monthlyExpenseByMonthDatatable";
import {
  getSingleMonthlyRedux,
  clearSingleMonthRedux,
} from "../../../actions/index";
import { Link } from "react-router-dom";

import { connect } from "react-redux";
import "./agent-commision.css";

export class MonthlyExpenseByMonth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      toggleModal: true,
      employee: null,
    };
  }

  componentDidMount = async () => {
    this.props.getSingleMonthlyRedux(
      this.props.match.params.month,
      "BUY PRODUCTS"
    );
  };
  componentWillUnmount = () => {
    this.props.clearSingleMonthRedux();
  };

  startToggleModal = async (employeeObj) => {
    if (employeeObj == null) {
      this.setState({ toggleModal: !this.state.toggleModal, employee: null });
    } else {
      this.setState({
        toggleModal: !this.state.toggleModal,
        employee: employeeObj,
      });
    }
  };

  render() {
    const { open } = this.state;
    const allExpenses = this.props.allExpenses || [];
    let total = 0;
    allExpenses.forEach((expense) => {
      total += parseInt(expense.amount) || 0;
    });

    console.log(this.props);
    return (
      <Fragment>
        <Breadcrumb title="Buy Products" parent="Monthly expense" />
        {/* <!-- Container-fluid starts--> */}
        <div className="container-fluid bp-page">
          <div className="row">
            <div className="col-sm-12">
              <div className="card bp-card">
                <div className="card-header bp-card-header">
                  <h5 className="bp-card-title">
                    <i className="icofont-calendar bp-card-icon"></i>
                    {this.props.match.params.month}
                  </h5>
                </div>
                <div className="card-body">
                  <div className="bp-total-chip">
                    <span className="bp-total-chip-label bp-stamp-font">Month Total</span>
                    <span className="bp-total-chip-value">{total}Tk</span>
                  </div>
                  <div className="clearfix"></div>
                  <div id="basicScenario" className="product-physical">
                    <Datatable
                      startToggleModal={this.startToggleModal}
                      history={this.props.history}
                      multiSelectOption={false}
                      myData={this.props.allExpenses}
                      pageSize={50}
                      pagination={true}
                      class="-striped -highlight"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ToastContainer />
        {/* <!-- Container-fluid Ends--> */}
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    allExpenses: state.expenses.singleMonth,
  };
};

export default connect(mapStateToProps, {
  getSingleMonthlyRedux,
  clearSingleMonthRedux,
})(MonthlyExpenseByMonth);
